module.exports = __webpack_public_path__ + "static/media/black-carat.1c8276ee.svg";